var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-table',{attrs:{"id":_vm.table_id,"options":_vm.options},on:{"action":_vm.triggerAction}}),_vm._v(" "),(_vm.isModalActive)?_c('app-due-payment-modal',{attrs:{"order-id":_vm.orderId,"value":true},on:{"modal-close":_vm.closeModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }